export class MiBrime {
   constructor(id, notas_orden, id_forma_pago, is_factura){
      this.ID = id
      this.Notas_Orden = notas_orden
      this.ID_Forma_Pago = id_forma_pago
      this.IsFactura = is_factura  
   }
   static fromServiceMibrime (mibrime) {
      return new MiBrime(
         mibrime.id,
         mibrime.notas_orden,
         mibrime.id_forma_pago,
         mibrime.is_factura
        );
   }   
}